import axios from 'axios';

const POS_DEVICE_STORAGE_KEY = 'cx_pos_device_secret';

// Configure axios base URL
// Use /api for production (served by Nginx on same domain)
// In development, use proxy (configured in package.json)
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : '';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export function getStoredPosDeviceSecret() {
  try {
    return localStorage.getItem(POS_DEVICE_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function setStoredPosDeviceSecret(secret) {
  try {
    if (secret) localStorage.setItem(POS_DEVICE_STORAGE_KEY, String(secret));
    else localStorage.removeItem(POS_DEVICE_STORAGE_KEY);
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearStoredPosDeviceSecret() {
  setStoredPosDeviceSecret('');
}

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const posSecret = getStoredPosDeviceSecret();
    if (posSecret) {
      config.headers['X-CX-Pos-Device'] = posSecret;
    }
    // Don't set Content-Type for FormData, let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Helper function to get full image URL
export const getImageUrl = (filePath) => {
  if (!filePath) return '';

  // If it's already a full URL, return as is
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
    return filePath;
  }

  // If it's a blob URL (preview), return as is
  if (filePath.startsWith('blob:')) {
    return filePath;
  }

  // Ensure path starts with /
  const cleanPath = filePath.startsWith('/') ? filePath : `/${filePath}`;

  // In production, images are served from /uploads (Nginx handles this)
  // In development, use proxy from package.json
  if (process.env.NODE_ENV === 'production') {
    return cleanPath;
  }

  // Development: proxy handles /uploads
  return cleanPath;
};

export default api;
